module.exports = __webpack_public_path__ + "static/media/info14_datos_actualizados_modifica.de2667e6.png";